import React from "react"
import Typography from "@mui/material/Typography";
import ButtonPreviews from "../../button/button-previews/button-previews.component";
import {Button, Paper,Box} from "@mui/material";
import {useRouter} from "next/router";

const CardQuestion = ({
                          titleHeader,
                          enableButtonPreviews=false,
                          numQuestion,
                          question,
                          subQuestion,
                          button1Link="",
                          button1Text="",
                          button2Link="",
                          button2Text="",
                          buttonPreviewLink="",
                          buttonPreviewText="",
                          button3Link="",
                          button3Text=""
})=>{
    const router = useRouter()
    return(
        <Paper elevation={10} >
            <Box sx={{height:500}}>
                    <Box sx={{mt:5,height:50 ,backgroundColor:"#1D2F56",color:"white", justifyContent:"center",display:"flex",alignItems:'center'}} >
                        <Typography variant="h1" component="h1" gutterBottom  sx={{
                            fontFamily: "Montserrat",
                            fontStyle: "normal",
                            fontWeight: 400,
                            fontSize: {xs: "24px",sm:"24px",md:"24px",lg:"24px",xl:"24px"},
                            textAlign: "left",
                        }}>
                            {titleHeader}
                        </Typography>
                    </Box>
                    <Box sx={{height:50,display:'flex',alignItems:'center',justifyContent:'left'}}>
                        {enableButtonPreviews && <ButtonPreviews href={buttonPreviewLink} text={buttonPreviewText}  /> }
                    </Box>

                    <Box sx={{height:240,display:'flex',alignItems:'center',justifyContent:'center'}} >
                        <Typography variant="h4" component="h1" gutterBottom  sx={{
                            fontFamily: "Montserrat",
                            fontStyle: "normal",
                            fontWeight: 400,
                            fontSize: "18px",
                            lineHeight: "22px",
                            textAlign: "center",
                            padding:5
                        }}>
                            {numQuestion}
                            <br /><br />
                            {question}
                            <br /><br />
                            <small>{subQuestion}</small>
                        </Typography>
                    </Box>

                    <Box sx={{display:'flex',alignItems:'center',justifyContent:'center',height:100,mb:3}} >

                        {
                            button1Text  && button1Link &&
                            <Button
                                onClick={()=>router.push(button1Link)}
                                variant={'outlined'} size={"large"} color={'inherit'}  sx={{width:100, borderRadius:5,textTransform:'none',mr:16}}>
                                {button1Text}
                            </Button>
                        }

                        {
                            button2Link  && button2Text &&
                        <Button onClick={()=>router.push(button2Link)}  variant={'outlined'} size={"large"} color={'inherit'} sx={{width:100,borderRadius:5,textTransform:'none'}}>
                            {button2Text}
                        </Button>
                        }
                        {
                            button3Text && button3Link &&
                            <Button onClick={()=>router.push(button3Link)}  variant={'contained'} size={"large"} color={'primary'} sx={{width:150,borderRadius:5,textTransform:'none'}}>
                                {button3Text}
                            </Button>
                        }
                    </Box>

                </Box>
        </Paper>
    )

}
export  default CardQuestion